<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="this.width" :height="this.height" viewBox="0 0 19 19" class="icon icon-logout">
    <g fill-rule="nonzero">
      <path
        d="M14.588 1.649a.579.579 0 0 0-.607-.075.613.613 0 0 0-.349.518.619.619 0 0 0 .28.562c2.767 1.99 3.962 5.603 2.952 8.925-1.01 3.32-3.992 5.58-7.364 5.58s-6.354-2.26-7.364-5.58c-1.01-3.322.185-6.936 2.952-8.925.25-.2.305-.567.124-.834a.582.582 0 0 0-.8-.171C1.218 3.944-.163 8.114 1.002 11.947c1.165 3.832 4.606 6.44 8.498 6.44 3.892 0 7.333-2.608 8.498-6.44 1.165-3.833-.216-8.003-3.41-10.298z"
      />
      <path
        d="M10.094 9.194V.613A.604.604 0 0 0 9.5 0a.604.604 0 0 0-.594.613v8.58c0 .339.266.613.594.613a.604.604 0 0 0 .594-.612z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LogoutIcon',
  props: {
    width: {
      type: String,
      default: '20'
    },
    height: {
      type: String,
      default: '20'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

g {
  fill: $primary;
}

.topnav-icon:hover {
  cursor: pointer;
}
</style>
